import React from "react";
import { Footer } from "./Footer";
import { GlobalErrorMessage } from "./GlobalErrorMessage";
import layoutStyles from "./Layout.module.css";
import { Menu } from "./Menu";

interface Props {
	children: React.ReactNode;
}

export default function BaseLayout(props: Props) {
	return (
		<div className={layoutStyles.container}>
			<div className={layoutStyles.top}>
				<Menu />
			</div>
			<main className={layoutStyles.middle}>
				<div className={layoutStyles.homeContainer}>
					<div className={layoutStyles.homeContent}>
						<GlobalErrorMessage />
						{props.children}
					</div>
				</div>
			</main>
			<div className={layoutStyles.bottom}>
				<Footer />
			</div>
		</div>
	);
}
